export default {"src":"/_next/static/media/TAS-card-number.dcdfcf6b.svg","height":142,"width":222,"blurWidth":0,"blurHeight":0};